import { enqueueSnackbar, UploadFile, DownloadFile } from 'actions';

import { ReportAvailabitilyExportRequest } from '../requests/RanReportAvailabilityRequests';

export const SET_FORM_STATE = 'SET_FORM_STATE';

const onSetFormState = (value) => ({
	type: SET_FORM_STATE,
	formState: value
});

export const SetFormState = (value) => (dispatch) => {
	dispatch(onSetFormState(value));
};

export const ReportAvailabitilyExport = (values, userId) => async (dispatch) => {
	await ReportAvailabitilyExportRequest(values, userId).then(response => {
		dispatch(DownloadFile(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};
